export function simplifiedLocale(lang: string) {
  return lang.split('_')[0];
}

type LocaleGender = 'male' | 'female' | 'neuter';

export function getOrdinalText(num: number, locale: string, gender: LocaleGender): string {
  switch (locale) {
    case 'en':
      return getEnOrdinalText(num);
    case 'ru':
      return getRuOrdinalText(num, gender);
    default: {
      return num.toString();
    }
  }
}

function getEnOrdinalText(num: number) {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  const v = num % 100;
  const suffix = v >= 11 && v <= 13 ? suffixes[0] : suffixes[Math.min(v % 10, 4)] || suffixes[0];
  return `${num}${suffix}`;
}

function getRuOrdinalText(num: number, gender: LocaleGender) {
  // Для 0 отдельное окончание
  if (num === 0) {
    if (gender === 'male') return `${num}-ой`;
    if (gender === 'female') return `${num}-ая`;
    return `${num}-ое`;
  }

  const lastTwoDigits = num % 100;

  // Для чисел от 11 до 19 окончание всегда однообразное
  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    if (gender === 'male') return `${num}-ый`;
    if (gender === 'female') return `${num}-ая`;
    return `${num}-ое`;
  }

  const lastDigit = num % 10;

  // Для остальных чисел окончание зависит от последней цифры
  let suffix = '';
  switch (lastDigit) {
    case 0:
      suffix = gender === 'male' ? 'ый' : gender === 'female' ? 'ая' : 'ое';
      break;
    case 1:
      suffix = gender === 'male' ? 'ый' : gender === 'female' ? 'ая' : 'ое';
      break;
    case 2:
      suffix = gender === 'male' ? 'ой' : gender === 'female' ? 'ая' : 'ое';
      break;
    case 3:
      suffix = gender === 'male' ? 'ий' : gender === 'female' ? 'я' : 'е';
      break;
    case 4:
      suffix = gender === 'male' ? 'ый' : gender === 'female' ? 'ая' : 'ое';
      break;
    case 5:
      suffix = gender === 'male' ? 'ый' : gender === 'female' ? 'ая' : 'ое';
      break;
    case 6:
      suffix = gender === 'male' ? 'ой' : gender === 'female' ? 'ая' : 'ое';
      break;
    case 7:
      suffix = gender === 'male' ? 'ой' : gender === 'female' ? 'ая' : 'ое';
      break;
    case 8:
      suffix = gender === 'male' ? 'ой' : gender === 'female' ? 'ая' : 'ое';
      break;
    case 9:
      suffix = gender === 'male' ? 'ый' : gender === 'female' ? 'ая' : 'ое';
      break;
    default:
      suffix = gender === 'male' ? 'ый' : gender === 'female' ? 'ая' : 'ое';
      break;
  }

  return `${num}-${suffix}`;
}
